<template>
    <section id="dnarepair2" class="bg-white">
        <div class="container py-5">
            <div class="col-12 my-5 w-title"><h3 class="text-title-content text-center text-primary wow slideInDown">{{ sectionNad1.title }}</h3></div>
            <div class="row mb-5 d-flex flex-wrap">
                <div class="col-12 text-black text-content text-center wow">
                    <p class="pt-1">{{ sectionNad1.title1 }}</p>
                    <p class="pt-1" v-html="sectionNad1.title2"></p>
                </div>
                <div class="col-12 my-5 w-title"><h3 class="text-title-content text-center text-primary wow slideInDown">{{ sectionNad1.title3 }}</h3></div>
                <div class="card card-ct-1">
                    <div class="card-body">
                        <div class="row mb-5 d-flex flex-wrap">
                            <div class="col-lg-4 col-4 wow slideInLeft">
                                <div class="card border-0 bg-transparent text-center hover-img">
                                    <img src="assets/img/dna-repair.png" class="card-img-top" alt="...">
                                    <div class="card-body px-0">
                                        <h3 class="card-text fs-4 lh-2 text-black">DNA REPAIR</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-4 wow slideInUp">
                                <div class="card border-0 bg-transparent text-center hover-img">
                                    <img src="assets/img/organ-age.png" class="card-img-top" alt="...">
                                    <div class="card-body px-0">
                                        <h3 class="card-text fs-4 lh-2 text-black">ORGAN AGE REVERSAL</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-4 wow slideInUp">
                                <div class="card border-0 bg-transparent text-center hover-img">
                                    <img src="assets/img/bost-cell.png" class="card-img-top" alt="...">
                                    <div class="card-body px-0">
                                        <h3 class="card-text fs-4 lh-2 text-black">BOST CELL ENERGY LEVEL</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SectionNad1',

  data(){
   return{
     lastScrollPosition: 0,
     sectionNad1:{
         title: null,
         title1: null,
         title2: null,
         title3: null,
        }
   }
 },

  mounted(){
    axios.get(`../../lang.json`).then(response => {
            let dataSectionsectionNad1
            if (localStorage.getItem('lang_nad') == 'id'){
                dataSectionsectionNad1 = response.data.id[0];
            } else if(localStorage.getItem('lang_nad') == 'en'){
                dataSectionsectionNad1= response.data.en[0];
            }
            this.sectionNad1.title = dataSectionsectionNad1.sectionNad1.title
            this.sectionNad1.title1 = dataSectionsectionNad1.sectionNad1.title1
            this.sectionNad1.title2 = dataSectionsectionNad1.sectionNad1.title2
            this.sectionNad1.title3 = dataSectionsectionNad1.sectionNad1.title3
            })

    window.addEventListener('scroll', this.onScroll)
  }
}
</script>
